import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Footer from "../components/footer/Footer";
import Head from "next/head";
import Layout from "../components/sidebarPro";
import Link from "next/link";
import React from 'react';
import Slider from "../components/score/carousel/Slider";
import styles from '../assets/css/score.module.scss';
import useTranslation from "next-translate/useTranslation";
var img1 = '../../../images/table/bronzeBadge.svg';
var img2 = '../../../images/table/silverBadge.svg';
var img3 = '../../../images/table/goldBadge.svg';
var img4 = '../../../images/table/diamondBadge.svg';

var Score = function Score() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var sliderSetting = {
    className: styles.slider,
    items: [{
      image: img1,
      title: t('score:bronze')
    }, {
      image: img2,
      title: t('score:silver')
    }, {
      image: img3,
      title: t('score:gold')
    }, {
      image: img4,
      title: t('score:diamond')
    }],
    descriptions: [t('score:if-you-play-for') + ' 3 ' + t('score:consecutive-days'), t('score:if-you-play-for') + ' 7 ' + t('score:consecutive-days'), t('score:if-you-play-for') + ' 14 ' + t('score:consecutive-days'), t('score:if-you-play-for') + ' 30 ' + t('score:consecutive-days')],
    colors: ['#BE5044', '#A5A5A5', '#D58C41', '#23BEE2']
  };
  return /*#__PURE__*/_jsxs(Layout, {
    page: "score",
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: t('score:wow-kanoon-rules')
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-5 ".concat(styles.wrapper),
      children: [/*#__PURE__*/_jsx("h3", {
        className: styles.title,
        children: t('score:score')
      }), /*#__PURE__*/_jsx("p", {
        className: styles.text,
        children: t('score:score-presentation')
      }), /*#__PURE__*/_jsx("p", {
        className: styles.text2,
        children: t('score:score-formula')
      }), /*#__PURE__*/_jsx(Slider, {
        setting: sliderSetting
      }), /*#__PURE__*/_jsxs("div", {
        className: "pl-3 pr-3",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h2", {
            className: "".concat(styles.text3, " ").concat(styles.bold, " mb-4"),
            children: t('score:national-english-rank')
          }), /*#__PURE__*/_jsx("div", {
            className: styles.firstBox,
            children: /*#__PURE__*/_jsx("p", {
              className: "".concat(styles.text3, " m-0"),
              children: t('score:national-english-rank-explanation')
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h2", {
            className: "".concat(styles.text3, " ").concat(styles.bold, " mb-4"),
            children: t('score:wow-story-factory')
          }), /*#__PURE__*/_jsx("p", {
            className: "".concat(styles.text3, " m-7"),
            children: t('score:story-factory-explanation')
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.firstBox,
            children: [/*#__PURE__*/_jsx("p", {
              className: "".concat(styles.text3, " m-0"),
              children: t('score:editors-feedback')
            }), /*#__PURE__*/_jsx("p", {
              className: "".concat(styles.text3, " m-0"),
              children: t('score:write-learn')
            }), /*#__PURE__*/_jsx("p", {
              className: "".concat(styles.text3, " m-0"),
              children: t('score:liking-stories')
            })]
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.secondBox,
            children: [/*#__PURE__*/_jsx("p", {
              className: "".concat(styles.text3, " ").concat(styles.bold, " m-0"),
              children: t('score:any-stage-contd')
            }), /*#__PURE__*/_jsx("p", {
              className: "".concat(styles.text3, " ").concat(styles.bold, " m-0"),
              children: /*#__PURE__*/_jsx("pre", {
                children: t('score:at-any-stage')
              })
            })]
          }), /*#__PURE__*/_jsx("p", {
            className: "".concat(styles.text3, " m-0"),
            children: t('score:any-stage-explanation')
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          className: "".concat(styles.writeYourStoryBtn, " shadow"),
          children: /*#__PURE__*/_jsx(Link, {
            href: "/wow-stories/getReady",
            children: /*#__PURE__*/_jsx("a", {
              children: t('score:write-your-story')
            })
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Footer, {})]
      })]
    })]
  });
};

export var __N_SSG = true;
export default Score;